import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LazyImage from "@insite/mobius/LazyImage";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { css } from "styled-components";
import Link from "@insite/mobius/Link";
import logger from "@insite/client-framework/Logger";

const enum fields {
    imageUrl = "imageUrl",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.imageUrl]: string;
    }
};

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
});

const productPromotionStyles = {
    image: {
        css: css`
        img {
            max-height: 80px;
            width: auto;
        }
        `,
    }
}

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasProductContext;

const ProductPromotions: React.FC<Props> = ({
    session,
    fields,
    productContext: {
        product,
        productInfo: { qtyOrdered, unitOfMeasure, inventory },
    },
}) => {
    if (!product.promotions || !session.isAuthenticated || product.promotions.length < 1) {
        return null;
    }

    logger.debug(product.promotions);

    const getPromoNameOrNameLink = (promo: any) => {
        if (promo.url) {
            return (
                <Link href={`/${promo.url}`} data-test-selector="cdt-promotions-link">
                    <Typography className="cdt-promotions-name"><b>{promo.name}</b></Typography>
                </Link>
            )
        }
        return (
            <Typography className="cdt-promotions-name"><b>{promo.name}</b></Typography>
        )
    };
    return (
        <StyledWrapper style={{ paddingTop: "15px" }}>
            <StyledWrapper style={{ display: "flex", alignItems: "center" }}>
                <LazyImage
                    style={{ marginRight: "15px", maxHeight: "80px" }}
                    {...productPromotionStyles.image}
                    src={fields.imageUrl}
                    width="auto"
                    altText="Promotions Image"
                    height="auto"
                />
                <Typography>{translate("Promotions are available for this product!")}</Typography>
            </StyledWrapper>
            <ul className="cdt-promotions-ul">
                {product.promotions.map(promo => (
                    <li className="cdt-promotions-li" key={promo.name}>
                        {getPromoNameOrNameLink(promo)}
                        {promo.description != "" && <Typography className="cdt-promotions-desc">: {promo.description}</Typography>}
                    </li>
                ))}
            </ul>
        </StyledWrapper>
    );
};

const productPromotionsModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductPromotions)),
    definition: {
        group: "Products",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.imageUrl,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
        ],
    },
};

export default productPromotionsModule;
